import type { Actions } from '../actions/types';
import type { ActionMessage } from '../types';
import { invokeAction } from './invoke';

export type DismissAction = ActionMessage<'dismiss', Actions | undefined>;

export const dismiss = invokeAction('uniclientAction', 'dismiss');
